export default __webpack_public_path__ + "static/media/protected.8334de99.png";